import { useTranslation } from 'react-i18next';
import { BillableMaterial } from '../types';
import { Box, Stack, Typography } from '@mui/material';
import { InformationTooltip } from '../../Prediction/InformationTooltip';
import BillableMaterialTooltipContent from './BillableMaterialTooltipContent';

type BillableMaterialItemProps = {
  material: BillableMaterial;
};

export default function BillableMaterialItem({ material }: BillableMaterialItemProps) {
  const { t } = useTranslation();

  return (
    <InformationTooltip tooltipElement={Box} tooltipContent={<BillableMaterialTooltipContent material={material} />}>
      <Stack
        direction='column'
        alignItems='stretch'
        justifyContent='center'
        flex={1}
        sx={{
          minHeight: '4rem',
          borderRadius: '10px',
          backgroundColor: 'white',
          border: '1px solid rgba(0, 0, 0, 0.12)',
          padding: '8px 12px',
          boxSizing: 'border-box',
          '&:hover': {
            border: '1px solid rgb(89, 109, 246, 0.4)',
          },
        }}
      >
        <Typography
          align='center'
          variant='body1'
          sx={{
            fontWeight: 700,
          }}
        >
          {material.articleNumber}
        </Typography>
        {material.name && (
          <Typography align='center' variant='inherit'>
            {t(material.name)}
          </Typography>
        )}
      </Stack>
    </InformationTooltip>
  );
}
